import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
    },
    {
      path: '/study',
      name: 'study',
      component: () => import('./views/Study.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue'),
    },
    {
      path: '/ways',
      name: 'ways',
      component: () => import('./views/Ways.vue'),
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/Service.vue'),
    },
  ]
})

export default kejianrouter